import InlineAlert from '../primitives/InlineAlert/InlineAlert';
import { Shield } from '@drift-labs/icons';

const CommunityVaultsCallout = () => {
	return (
		<InlineAlert
			variant="info"
			customIcon={Shield}
			title="These managers fulfill the basic requirements for vault operation but have not completed KYB."
		/>
	);
};

export default CommunityVaultsCallout;
